import * as React from 'react';

import * as styles from './TwoColumnsLayout.css';

interface IProjectsListTwoColumnsLayoutProps {
  children?: React.ReactNode;
}

export const TwoColumnsLayout: React.FC<IProjectsListTwoColumnsLayoutProps> = ({ children }) => {
  return <div className={styles['container']}>{children}</div>;
};
